// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import DownloadSiHaDocumentationRequestModel from '../../model/download-si-ha-documentation-request-model';
import DownloadSiHaDocumentationRequestDTO from '../dto/download-si-ha-documentation-request-dto';
import dtoSchema from '../schemas/download-si-ha-documentation-request-schema';

export default abstract class DownloadSiHaDocumentationRequestModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<DownloadSiHaDocumentationRequestDTO>) {
    super();
    if (data) {
      this.id = data.id;
    }
  }
  /**
  * @type {int64}
  */
  id?: number;

  static toModel(dto: DeepPartial<DownloadSiHaDocumentationRequestDTO>): DownloadSiHaDocumentationRequestModel;
  static toModel(dto: DeepPartial<DownloadSiHaDocumentationRequestDTO> | undefined | null): DownloadSiHaDocumentationRequestModel | undefined;
  static toModel(dto: DeepPartial<DownloadSiHaDocumentationRequestDTO> | undefined | null): DownloadSiHaDocumentationRequestModel | undefined {
    return dto ? new DownloadSiHaDocumentationRequestModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<DownloadSiHaDocumentationRequestModel> | DownloadSiHaDocumentationRequestModel): DownloadSiHaDocumentationRequestDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      id: unwrapped.id,
    } as DownloadSiHaDocumentationRequestDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for DownloadSiHaDocumentationRequestModel, can not map to DownloadSiHaDocumentationRequestDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
